module.exports = __webpack_public_path__ + "static/media/facebook-desktop.9b742d99.png";